import { render, staticRenderFns } from "./DispatchAlertDetailsView.vue?vue&type=template&id=6dbf23fd&scoped=true&"
import script from "./DispatchAlertDetailsView.vue?vue&type=script&lang=js&"
export * from "./DispatchAlertDetailsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dbf23fd",
  null
  
)

export default component.exports